export default __webpack_public_path__ + "static/media/practiceQuestionsIcon.816cf1b3.svg";